import { Fragment, useEffect, useState } from "react";
import "./css/servicios.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Accordion from "react-bootstrap/Accordion";
import Image from "react-bootstrap/Image";
import BannerDatos from "../../images/servicio/bg-cloud.webp";
import BannerDatosmobile from "../../images/servicio/bg-cloud-m.webp";
import LogoGarantia from "../../images/servicio/garantia/hyundai-garantia-logo.webp";
import { useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet';

function InfoCondiciones() {
    const location = useLocation();
    const [optionSelected, setOptionSelected] = useState();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const singleValue = queryParams.get('opc');
        switch (singleValue) {
            case "vnuevos":
                setOptionSelected("0");
                break;
            case "repuestos":
                setOptionSelected("2");
                break;
            default:
                setOptionSelected(undefined);
        }
    }, [location])

    return (
        <Fragment>
            <Container fluid={true} className="banner-servicios d-none d-md-block">
                <Row>
                    <Col md={12} className="px-0">
                        <Helmet>
                            <link rel="preload" href={BannerDatos} as="image" />
                        </Helmet>
                        <Card>
                            <img
                                src={BannerDatos}
                                alt="Hyundai Ecuador Condiciones"
                                className="card-bannerdatos"
                            />
                            <Card.Img
                                src={BannerDatosmobile}
                                alt="Hyundai Ecuador Condiciones"
                                className="d-block d-sm-none"
                            />
                            <Card.ImgOverlay className="d-flex">
                                <Card.Title className="bg-banner-servicios w-100 d-flex align-items-center">
                                    <div className="mx-auto w-100">
                                        <h1 className="servicios-banner-titulo">Condiciones.</h1>
                                        <br />
                                        <h2 className="servicios-banner-subtitulo">
                                            Hyundai cuida tu inversión a través de la mejor garantía
                                            transferible del mercado.
                                        </h2>
                                    </div>
                                </Card.Title>
                            </Card.ImgOverlay>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Container className="specs-container mt-4 mt-md-5 mb-5 pb-3 pt-md-3">
                <Row className="row-logoGarantia">
                    <Col md={5} className="img-logoGarantia">
                        <Image src={LogoGarantia} alt="Hyundai garantia" className="img-logoGarantia" fluid />
                    </Col>
                </Row>
                <Row>
                    <Col md={12} className="acordeon-garantia mt-4 mt-md-5 pt-md-3">
                        <Accordion activeKey={optionSelected}>
                            <Card>
                                <Card.Header>
                                    <Accordion.Toggle
                                        as={Card.Header}
                                        variant="link"
                                        eventKey="0"
                                        className="text-decoration-none"
                                    >
                                        Garantía básica para vehículos nuevos.
                                    </Accordion.Toggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="0">
                                    <Card.Body>
                                        <p className="garantia-texto">
                                            Cualquier componente de su vehículo nuevo Hyundai, excepto
                                            los especificados a continuación, estarán cubiertos a
                                            partir de la fecha de venta a cliente con una cobertura de
                                            10 años ó 160.000 Kms, lo que ocurra primero.
                                        </p>
                                        <p className="garantia-item">
                                            <span className="font-weight-bold">
                                                Batería (original del vehículo):{" "}
                                            </span>
                                            2 años ó 40.000 Kms, lo que ocurra primero.
                                        </p>
                                        <p className="garantia-item">
                                            <span className="font-weight-bold">
                                                Recarga de refrigerante de aire acondicionado:
                                            </span>{" "}
                                            1 año / sin límite de Kms.
                                        </p>
                                        <p className="garantia-item">
                                            <span className="font-weight-bold">
                                                Radio (original del vehículo):
                                            </span>{" "}
                                            2 años ó 40.000 Kms, lo que ocurra primero.
                                        </p>
                                        <p className="garantia-item">
                                            <span className="font-weight-bold">Pintura:</span> 5 años
                                            ó 100.000 Kms, lo que ocurra primero (*).
                                        </p>
                                        <p className="garantia-item">
                                            <span className="font-weight-bold">
                                                Anti perforación:
                                            </span>{" "}
                                            5 años ó 100.000 Kms, lo que ocurra primero (*).
                                        </p>
                                        <p className="garantia-item">
                                            <span className="font-weight-bold">Llantas:</span>{" "}
                                            Cobertura de garantía otorgado por el fabricante.
                                        </p>
                                        <p className="garantia-texto">
                                            Para mantener válida la garantía para todos los
                                            componentes arriba listados, todos los mantenimientos del
                                            vehículo Hyundai, deben ser realizados en cualquiera de
                                            los talleres Hyundai autorizados a nivel nacional.
                                        </p>
                                        <p className="garantia-texto">(*) Aplican restricciones.</p>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                            <Card>
                                <Card.Header>
                                    <Accordion.Toggle
                                        as={Card.Header}
                                        variant="link"
                                        eventKey="1"
                                        className="text-decoration-none"
                                    >
                                        Garantía de vehículos híbridos.
                                    </Accordion.Toggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="1">
                                    <Card.Body>
                                        <p className="garantia-texto">
                                            Cualquier componente del sistema híbrido de su vehículo,
                                            excepto los especificados en la sección “Garantía básica
                                            de vehículo nuevos”, estarán cubiertos a partir de la
                                            fecha a cliente con una cobertura de 10 años ó 160.000
                                            Kms, lo que ocurra primero.
                                        </p>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                            <Card>
                                <Card.Header>
                                    <Accordion.Toggle
                                        as={Card.Header}
                                        variant="link"
                                        eventKey="2"
                                        className="text-decoration-none"
                                    >
                                        Garantía de reemplazo de partes y accesorios.
                                    </Accordion.Toggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="2">
                                    <Card.Body>
                                        <p className="garantia-texto">
                                            Las partes y accesorios genuinos Hyundai suministrados por
                                            el distribuidor Hyundai autorizado e instalados en
                                            cualquier concesionario Hyundai autorizado, están
                                            cubiertos por 1 año ó 20.000 Kms, lo que ocurra primero.
                                        </p>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}
export default InfoCondiciones;